import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function clearExperienceDefaults(): RootActionTypes {
  return {
    type: ActionTypes.CLEAR_EXPERIENCE_DEFAULTS,
  };
}
